import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Format } from '../..'
import { Strong } from '../../shared/Gem/GemDetail'

const MonthlyPayment = ({ value, ...restProps }) => (
  <Strong {...restProps}>
    <FormattedMessage
      id='Homeowner.purchasePower.monthlyPayment'
      defaultMessage='{monthly}/mo'
      values={{
        monthly: <Format.Currency format='0,0' value={value} />
      }}
    />
  </Strong>
)

export default MonthlyPayment
